import { Backdrop, CircularProgress } from "@mui/material";

export const Loading = () => {
  return (
    <Backdrop open sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <CircularProgress />
    </Backdrop>
  );
};
